const IMPORTED_EPISODE_PREFIX = "bidclub-";

export function podcastPublicSlug(
  episodeId: string,
  sourceProvider: string | null,
): string {
  if (
    sourceProvider?.toLocaleLowerCase() === "bidclub"
    && episodeId.startsWith(IMPORTED_EPISODE_PREFIX)
  ) {
    return episodeId.slice(IMPORTED_EPISODE_PREFIX.length);
  }
  return episodeId;
}

export function podcastCanonicalPath(publicSlug: string): string {
  return `/podcasts/${encodeURIComponent(publicSlug)}`;
}

export function podcastLookupIds(publicSlug: string): [string, string] {
  return [publicSlug, `${IMPORTED_EPISODE_PREFIX}${publicSlug}`];
}
